import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {reInitMenu} from '../helpers'
import {ThemeModeProvider} from '../partials'
import {WarehouseFilterBar} from '../../app/custom/warehouse/WarehouseFilter'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Sidebar} from './components/sidebar'
import {ToolbarWrapper} from './components/toolbar'
import {PageDataProvider} from './core'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='flex h-screen overflow-hidden bg-gray-50' id='kt_app_root'>
          {/* Sidebar */}
          <Sidebar />
          {/* Main area: header + content + footer */}
          <div className='flex flex-col flex-1 overflow-hidden' id='kt_app_page'>
            <div className='border-b border-gray-200 shrink-0'>
              <HeaderWrapper />
            </div>
            <WarehouseFilterBar />
            <div className='flex flex-col flex-1 overflow-auto' id='kt_app_main'>
              <div className='flex-1'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
